import { Link } from "react-router-dom";
import { MOCK_CHATS, formatTimeFromNow } from "@/lib/mockData";

const Chats = () => {
  return (
    <div className="pt-5" data-testid="chats-page">
      <h1 className="font-heading font-black text-3xl mb-1">Chats</h1>
      <p className="text-sm text-[#555555] mb-5">Group chats for every activity you're in.</p>

      <div className="space-y-3">
        {MOCK_CHATS.map((c, i) => (
          <Link
            key={c.id}
            to={`/chats/${c.id}`}
            className="brutal-card p-4 flex items-center gap-3 fade-up"
            style={{ animationDelay: `${i * 60}ms` }}
            data-testid={`chat-row-${c.id}`}
          >
            <div className="flex -space-x-2">
              {c.avatars.map((a, j) => (
                <img key={j} src={a} className="w-9 h-9 rounded-full brutal-border object-cover bg-white" alt="" />
              ))}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <h3 className="font-heading font-bold truncate">{c.title}</h3>
                <span className="text-[10px] text-[#555555] font-mono shrink-0">{formatTimeFromNow(c.last_iso)}</span>
              </div>
              <p className="text-xs text-[#555555] truncate">
                <span className="font-bold text-[#0A0A0A]">{c.last_sender}:</span> {c.last_message}
              </p>
            </div>
            {c.unread > 0 && (
              <span className="w-6 h-6 bg-[#FF6A2C] text-white rounded-full brutal-border font-bold text-xs flex items-center justify-center">
                {c.unread}
              </span>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Chats;
